import { render, staticRenderFns } from "./GroupsHandler.vue?vue&type=template&id=44b3054a"
import script from "./GroupsHandler.vue?vue&type=script&lang=ts"
export * from "./GroupsHandler.vue?vue&type=script&lang=ts"
import style0 from "./GroupsHandler.vue?vue&type=style&index=0&id=44b3054a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports